export class Image {
  constructor(difference) {
    this.styleId = 1
    this.width = 400
    this.height = 225
    this.top = 10
    this.left = 10
    this.innerElement = "imageComponent"
    this.shapeType = "rectangle" // square， rectangle，radius， round
    this.shapeChecked = true
    this.borderChecked = false
    this.borderShadowChecked = false
    this.rotateChecked = false
    this.borderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.rotate = 0
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.hoverZoomLevel = 1
    this.openBlankPage = true
    this.linkUrl = ""
    this.internalLinkName = ""
    this.linkAddress = "自定义"
    this.accessRulers = []
    this.imgName = "正方形"
    this.iconColor = "#444444"
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.zoomToView = false
    this.zoomPosition = "right bottom"
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
